// Paydaşlar için belirleyici renkler.
// - Combobox input'larında küçük renk kutusu (eski P/K/T rozetlerinin yerine).
// - Callout notlarında header band + çerçeve + leader line + marker rengi.
//
// Renk kaynakları:
//   1. PERSON_FIELDS / FIRM_FIELDS key → ROLE_COLORS sabit map
//   2. authorRole etiket string → ROLE_LABEL_TO_KEY üzerinden key bulunur
//   3. yukarıdakiler tutmazsa string'den hash ile palette renk seçilir

const ROLE_COLORS = {
  // PERSON_FIELDS
  malSahibi:        '#FFA726', // amber
  muteahhit:        '#26A69A', // teal
  mimariMuellif:    '#42A5F5', // blue
  elektrikMuellif:  '#FFCA28', // gold/yellow
  mekanikMuellif:   '#EF5350', // red
  kontrolMuhendis:  '#AB47BC', // purple
  // FIRM_FIELDS
  yapiDenetimId:    '#66BB6A', // green
  elektrikDagitimId:'#FFEE58', // light yellow
  telekomId:        '#26C6DA', // cyan
  itfaiyeId:        '#FF7043', // deep orange
  belediyeId:       '#5C6BC0', // indigo
  // Diğer
  client:           '#8D6E63', // brown — Müşteri (Genel Bilgiler)
  owner:            '#9E9E9E', // grey — Proje Sahibi
};

// Backend authorRole etiketleri ↔ key
const ROLE_LABEL_TO_KEY = {
  'Mal Sahibi':         'malSahibi',
  'Mal Sahibi / Isveren':'malSahibi',
  'Mal Sahibi / İşveren':'malSahibi',
  'Müteahhit':          'muteahhit',
  'Muteahhit':          'muteahhit',
  'Mimari Müellif':     'mimariMuellif',
  'Mimari Muellif':     'mimariMuellif',
  'Elektrik Müellifi':  'elektrikMuellif',
  'Elektrik Müellif':   'elektrikMuellif',
  'Elektrik Muellif':   'elektrikMuellif',
  'Mekanik Müellifi':   'mekanikMuellif',
  'Mekanik Müellif':    'mekanikMuellif',
  'Mekanik Muellif':    'mekanikMuellif',
  'Kontrol Mühendisi':  'kontrolMuhendis',
  'Kontrol Muhendisi':  'kontrolMuhendis',
  'Yapı Denetim':       'yapiDenetimId',
  'Yapi Denetim':       'yapiDenetimId',
  'Elektrik Dağıtım Firması':'elektrikDagitimId',
  'Elektrik Dagitim Firmasi':'elektrikDagitimId',
  'Telekom':            'telekomId',
  'İtfaiye':            'itfaiyeId',
  'Itfaiye':            'itfaiyeId',
  'Belediye':           'belediyeId',
  'Müşteri':            'client',
  'Musteri':            'client',
  'Proje Sahibi':       'owner',
};

// Hash-fallback palette
const HASH_PALETTE = [
  '#5E72E4', '#11CDEF', '#2DCE89', '#FB6340', '#F5365C',
  '#8965E0', '#FFC107', '#EF6C00', '#00ACC1', '#43A047',
];

function hashString(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

// Rolü key veya etiketten çöz; yoksa null döner.
export function colorForRoleKey(key) {
  if (!key) return null;
  return ROLE_COLORS[key] || null;
}

export function colorForRoleLabel(label) {
  if (!label) return null;
  const trimmed = String(label).trim();
  const key = ROLE_LABEL_TO_KEY[trimmed];
  if (key) return ROLE_COLORS[key];
  // Doğrudan key olarak verilmiş olabilir
  if (ROLE_COLORS[trimmed]) return ROLE_COLORS[trimmed];
  return null;
}

// Bir not / paydaş için renk çöz: önce role key, sonra label, son hash fallback.
export function resolveStakeholderColor({ key, role, fallbackSeed } = {}) {
  return (
    colorForRoleKey(key)
    || colorForRoleLabel(role)
    || HASH_PALETTE[hashString(fallbackSeed || role || key || 'x') % HASH_PALETTE.length]
  );
}

// "#RRGGBB" → 0xRRGGBB (THREE.js için)
export function hexToInt(hex) {
  if (!hex) return 0xffffff;
  const s = hex.startsWith('#') ? hex.slice(1) : hex;
  return parseInt(s, 16) || 0xffffff;
}

// Bir renk üzerine yarı saydam bir varyant döndür (header band için)
export function withAlpha(hex, alpha) {
  if (!hex) return `rgba(255,255,255,${alpha})`;
  const s = hex.startsWith('#') ? hex.slice(1) : hex;
  const n = parseInt(s, 16) || 0xffffff;
  const r = (n >> 16) & 0xff;
  const g = (n >> 8) & 0xff;
  const b = n & 0xff;
  return `rgba(${r},${g},${b},${alpha})`;
}
